import './styles.css';

import Placeholder from '@tiptap/extension-placeholder';
import type { Content } from '@tiptap/react';
import {
  mergeAttributes,
  ReactNodeViewRenderer,
  useEditor,
} from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';

import suggestion from './suggestion';

import { default as MentionExtension } from '@tiptap/extension-mention';
import MentionComponent from './MentionComponent';

export const CustomMention = MentionExtension.extend({
  addNodeView() {
    return ReactNodeViewRenderer(MentionComponent);
  },
  parseHTML() {
    return [
      {
        tag: 'mention-component',
      },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ['mention-component', mergeAttributes(HTMLAttributes)];
  },
  renderText({ node }) {
    return `@${node.attrs.label.name}`;
  },
});

export const usePaddockEditor = ({
  initialContent,
  placeholder = 'Leave a comment...',
  editable = true,
}: {
  initialContent?: Content;
  placeholder?: string;
  editable?: boolean;
}) => {
  const editor = useEditor({
    extensions: [
      StarterKit,
      Placeholder.configure({
        // Use a placeholder:
        placeholder: placeholder,
        // Use different placeholders depending on the node type:
        // placeholder: ({ node }) => {
        //   if (node.type.name === 'heading') {
        //     return 'What’s the title?'
        //   }

        //   return 'Can you add some further context?'
        // },
      }),
      CustomMention.configure({
        HTMLAttributes: {
          class: 'mention',
        },
        suggestion,
      }),
    ],
    content: initialContent,
    immediatelyRender: false,
    editable,
  });

  return { editor };
};
